// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"86":"complete","251":"checkout","353":"contact","420":"tnc","639":"categories","949":"cart","962":"home","964":"product"}[chunkId] + "." + {"86":"f2cddad6","251":"e8759a26","353":"0e781137","420":"bd8cba1c","639":"d3264dc4","949":"bf53bc6b","962":"c766c3e3","964":"bf18dd39"}[chunkId] + ".css";
};